module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'pdi9d6dy',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
